(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var styles = exports.styles = ".rz-container {\n  background-color: #fbfbfb;\n  padding: 20px 15px 20px 20px; }\n\n.rz-container-single-exclusive {\n  padding-bottom: 0; }\n\n.rz-list {\n  list-style: none;\n  margin: 0;\n  padding: 0; }\n\n.rz-item {\n  margin-top: 30px; }\n\n.rz-item--first {\n  margin-top: 10px; }\n\n.rz-list__action {\n  display: block;\n  text-decoration: none; }\n\n.rz-list__action:hover {\n  outline: 0;\n  text-decoration: none; }\n\n.rz-list__header {\n  display: table;\n  width: 100%;\n  color: #5c656e; }\n\n.rz-list__header h4 {\n  color: #2f3840;\n  margin-bottom: 3px; }\n\n.rz-list__right {\n  padding-left: 10px;\n  text-align: right;\n  display: table-cell;\n  vertical-align: top;\n  width: 98px; }\n\n.rz-list__logo-wrapper {\n  border: 1px solid #d2d6d9;\n  display: block;\n  padding: 2px 6px 3px;\n  background-color: #ffffff; }\n\n.rz-item--exclusive .rz-list__logo-wrapper {\n  position: relative;\n  top: -30px; }\n\n.rz-list__logo {\n  display: block; }\n\n.rz-highlight-orange {\n  color: #eb612a;\n  font-weight: 700; }\n\n.rz-exclusive-footer {\n  display: table;\n  width: 100%;\n  padding-bottom: 15px; }\n\n.rz-exclusive-container {\n  margin-left: -20px;\n  margin-right: -15px;\n  background-color: #ffffff; }\n\n.rz-exclusive-container__content {\n  margin-left: 20px;\n  margin-right: 15px; }\n\n.rz-exclusive-banner {\n  margin-bottom: 15px; }\n\n.rz-exclusive-banner__empty {\n  height: 1em; }\n";

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Xhr = Xhr;
exports.xhrInitParams = xhrInitParams;
exports.xhrSetMultiCallback = xhrSetMultiCallback;
exports.xhrOpen = xhrOpen;
exports.xhrSendHeaders = xhrSendHeaders;
exports.xhrSendBody = xhrSendBody;
exports.xhrDestroy = xhrDestroy;
exports.parseParams = parseParams;
exports.eventToResult = eventToResult;
exports.xhrGetDecodedResponseBody = xhrGetDecodedResponseBody;
exports.isJSONEncodable = isJSONEncodable;
exports.isStatusOk = isStatusOk;
exports.headersToDict = headersToDict;
/**
 * TODO
 *   shorter function names
 */

/**
 * Shortcuts
 */

function Xhr(params, onDone) {
  var xhr = new XMLHttpRequest();
  xhrInitParams(xhr, params);

  xhrSetMultiCallback(xhr, function xhrDone(event) {
    xhr.result = eventToResult(event);
    if (isFunction(onDone)) onDone(xhr.result);
  });

  xhrOpen(xhr);
  xhrSendHeaders(xhr);
  xhrSendBody(xhr);

  return xhr;
}

/**
 * Primary Utils
 */

function xhrInitParams(xhr, params) {
  xhr.params = parseParams(params);
}

function xhrSetMultiCallback(xhr, fun) {
  validate(isFunction, fun);
  xhr.onabort = xhr.onerror = xhr.onload = xhr.ontimeout = fun;
}

function xhrOpen(xhr) {
  // In some circumstances Chrome may fail to report upload progress. Accessing
  // `.upload` before opening the request magically solves the problem.
  xhr.upload;
  var _xhr$params = xhr.params,
      method = _xhr$params.method,
      url = _xhr$params.url,
      async = _xhr$params.async,
      username = _xhr$params.username,
      password = _xhr$params.password;

  xhr.open(method, url, async, username, password);
}

function xhrSendHeaders(xhr) {
  var rawHeaders = xhr.params.headers;

  var headers = pickBy(meaningfulPair, rawHeaders);
  for (var key in headers) {
    xhr.setRequestHeader(key, headers[key]);
  }
}

function xhrSendBody(xhr) {
  var body = xhr.params.body;

  xhr.send(body);
}

function xhrDestroy(xhr) {
  if (isDict(xhr) && isFunction(xhr.abort)) xhr.abort();
}

/**
 * Secondary Utils
 */

function parseParams(rawParams) {
  validate(isDict, rawParams);
  validate(isString, rawParams.url);
  if (rawParams.method) validate(isString, rawParams.method);

  var method = (rawParams.method || 'GET').toUpperCase();

  return merge(rawParams, {
    rawParams: rawParams,
    method: method,
    async: rawParams.async === false ? false : true,
    url: encodeUrl(rawParams.url, method, rawParams.body),
    headers: isDict(rawParams.headers) ? rawParams.headers : {},
    body: encodeBody(rawParams.body, method, getContentTypeHeader(rawParams.headers))
  });
}

function eventToResult(event) {
  var xhr = event.target,
      reason = event.type;

  var complete = xhr.readyState === xhr.DONE;
  return {
    xhr: xhr,
    event: event,
    params: xhr.params,
    complete: complete,
    reason: reason,
    status: xhr.status,
    ok: complete ? isStatusOk(xhr.status) : undefined,
    headers: headersToDict(xhr.getAllResponseHeaders()),
    body: xhrGetDecodedResponseBody(xhr)
  };
}

function xhrGetDecodedResponseBody(xhr) {
  var type = xhr.getResponseHeader('content-type');

  return (/json/.test(type) ? jsonDecode(xhr.responseText) : /html/.test(type) ? new DOMParser().parseFromString(xhr.responseText, 'text/html') : /xml/.test(type) ? new DOMParser().parseFromString(xhr.responseText, 'text/xml') : xhr.responseText
  );
}

function isReadOnly(method) {
  return (/get|head|options/i.test(method)
  );
}

function encodeUrl(url, method, body) {
  return isReadOnly(method) && isDict(body) ? appendQuery(url, body) : url;
}

function getContentTypeHeader(headers) {
  for (var key in headers) {
    if (/content-type/i.test(key)) return headers[key];
  }
}

function encodeBody(body, method, contentType) {
  return isReadOnly(method) ? null : /application\/json/.test(contentType) && isJSONEncodable(body) ? jsonEncode(body) : /application\/x-www-form-urlencoded/.test(contentType) && isDict(body) ? formdataEncode(body) : body;
}

// Problem:
//   JSON.stringify(null)       = 'null'
//   JSON.stringify(undefined)  = undefined
function jsonEncode(value) {
  try {
    return JSON.stringify(value);
  } catch (_) {
    return 'null';
  }
}

// Problem:
//   JSON.parse('')                = exception!
//   JSON.parse(JSON.stringify())  = exception!
function jsonDecode(value) {
  try {
    return JSON.parse(value);
  } catch (_) {
    return null;
  }
}

function isJSONEncodable(value) {
  return isDict(value) || isArray(value);
}

function isStatusOk(status) {
  return status >= 200 && status <= 299;
}

function appendQuery(url, queryDict) {
  var search = formdataEncode(queryDict);
  return !search ? url : '' + url + (/\?/.test(url) ? '&' : '?') + search;
}

function formdataEncode(rawDict) {
  var pairs = [];
  var dict = pickBy(meaningfulPair, rawDict);
  for (var key in dict) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(dict[key]));
  }
  return pairs.join('&');
}

function headersToDict(headersString) {
  var headerDict = {};

  splitLines(headersString).map(splitHeader).filter(Boolean).forEach(function (_ref) {
    var _header = _ref[0],
        key = _ref[1],
        value = _ref[2];

    headerDict[key.toLowerCase()] = value;
  });

  return headerDict;
}

function splitLines(string) {
  return string.split(/$/m);
}

function splitHeader(headerString) {
  return headerString.match(/^\s*([^:]+)\s*:\s*(.+)\s*$/m);
}

function isObject(value) {
  return value !== null && typeof value === 'object';
}

function isDict(value) {
  return isObject(value) && isPlainPrototype(Object.getPrototypeOf(value));
}

function isPlainPrototype(value) {
  return value === null || value === Object.prototype;
}

function isArray(value) {
  return value instanceof Array;
}

function isString(value) {
  return typeof value === 'string';
}

function isFunction(value) {
  return typeof value === 'function';
}

function validate(test, value) {
  if (!test(value)) throw Error('Expected ' + value + ' to satisfy test ' + test.name);
}

function merge(left, right) {
  var out = {};
  for (var key in left) {
    out[key] = left[key];
  }for (var _key in right) {
    out[_key] = right[_key];
  }return out;
}

function pickBy(fun, dict) {
  var out = {};
  for (var key in dict) {
    if (fun(dict[key], key)) out[key] = dict[key];
  }
  return out;
}

function meaningfulPair(left, right) {
  return meaningful(left) && meaningful(right);
}

function meaningful(value) {
  return value != null && value !== '';
}
},{}],3:[function(require,module,exports){
'use strict';

var Rz = require('./rz');

var w = window ? window : {};
var d = document ? document : {};

w.TES = w.TES || {};
w.TES.rz = new Rz(w, d);
w._rz = w.TES.rz;

},{"./rz":4}],4:[function(require,module,exports){
'use strict';

var _xhttp = require('xhttp');

var _sections = require('./sections');

var _sections2 = _interopRequireDefault(_sections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Rz(rzWindow, rzDocument) {

  var tesPageMetadata = rzWindow.TES && rzWindow.TES.pageMetadata;
  var metadataFields = ['jobCatCodes', 'subjects', 'workplaces', 'positions', 'years', 'tags'];

  var asArray = function asArray(value) {
    return Array.isArray(value) ? value : [value];
  };
  var valuesFor = function valuesFor(field) {
    return tesPageMetadata && tesPageMetadata[field] ? asArray(tesPageMetadata[field]).map(function (value) {
      return field + '=' + encodeURIComponent(value);
    }) : [];
  };

  var metadataForUrls = metadataFields.map(function (field) {
    return valuesFor(field);
  });
  var flattenedAndJoined = metadataForUrls.reduce(function (accumulator, current) {
    if (current.length > 0) {
      return accumulator.concat(current);
    }
    return accumulator;
  }, []).join('&');

  var rz_nodes = [].slice.call(rzDocument.querySelectorAll('[data-rz]'));

  rz_nodes.forEach(function (node) {
    var sectionName = node.getAttribute('data-rz');

    var emit_event = function emit_event(status, error, url, recover) {
      return rzWindow.TES._rz_listeners && rzWindow.TES._rz_listeners.forEach(function (listener) {
        return listener({ sectionName: sectionName, status: status, error: error, url: url, recover: recover });
      });
    };

    var section = _sections2.default[sectionName];

    if (!section) {
      emit_event('ERROR', 'unknown section');
      return;
    }

    var params = {
      url: section.endpoint + '?' + flattenedAndJoined
    };

    new _xhttp.Xhr(params, function (response) {
      if (!response.ok) {
        emit_event('ERROR', '' + response.status, params.url, function (html) {
          return node.innerHTML = html;
        });
        return;
      }

      if (!response.body.results || response.body.results.length === 0) {
        emit_event('ERROR', 'no results', params.url, function (html) {
          return node.innerHTML = html;
        });
        return;
      }

      node.innerHTML = section.render(response.body.results);
      emit_event('SUCCESS');
    });
  });
}

module.exports = Rz;

},{"./sections":5,"xhttp":2}],5:[function(require,module,exports){
'use strict';

var _styles = require('../dist/styles.js');

var sections = {
  jobs: {
    endpoint: '/api/rz/jobs',
    render: function render(results) {
      var limit = 5;
      for (var i = 0; i < results.length; i++) {
        if (results[i].type === 'exclusive') {
          limit = 4;
        }
      }
      var items = [];
      for (var position = 1; position <= limit; position++) {
        var item = results[position - 1];
        if (item) {
          var subheading = item.organisation && item.location ? item.organisation + ', ' + item.location : item.organisation || item.location || '';
          var logoDiv = item.logo ? '<div class="rz-list__logo-wrapper"><img class="rz-list__logo" width="74" height="37" src="' + item.logo + '"></div>' : '';
          var firstItemClass = position === 1 ? 'rz-item--first' : '';
          if (item.type === 'exclusive') {
            item.shortDescription = '';
            if (item.description) {
              var trimmed = item.description.substr(0, 75);
              trimmed = trimmed.substr(0, Math.min(trimmed.length, trimmed.lastIndexOf(' ')));
              item.shortDescription = trimmed + '…';
            }
            var applyBy = item.applyBy ? 'Apply by ' + item.applyBy : '';
            var bannerDiv = item.banner ? '<div class="rz-exclusive-banner"><img src="' + item.banner + '" srcset="' + item.banner2x + ' 2x" width="100%"/></div>' : '<div class="rz-exclusive-banner rz-exclusive-banner__empty"></div>';
            items.push('\n          <li class="rz-item ' + firstItemClass + '" data-position="' + position + '">\n            <a data-mz="true" data-module="job-exclusive" data-id="' + item.promoId + '" href="' + item.url + '" class="rz-list__action">\n              <div class="rz-exclusive-container">\n                ' + bannerDiv + '\n                <div class="rz-exclusive-container__content">\n                  <header class="rz-list__header">\n                    <h4 class="heading heading--sm heading--bold">' + item.title + '</h4>\n                    <p class="text text--xxs text--bold">' + subheading + '</p>\n                    <p class="text text--xxs t-rz-description" title="' + item.description + '">' + item.shortDescription + '</p>\n                    <div class="rz-list__right">\n                      ' + logoDiv + '\n                    </div>\n                  </header>\n                  <div class="rz-exclusive-footer">\n                    <span class="text--xxs rz-highlight-orange">' + applyBy + '</span>\n                    <div class="rz-list__right">\n                      <span class="tes-btn tes-btn--xs tes-btn--block tes-btn--secondary">View job</span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </a>\n          </li>\n          ');
          } else {
            items.push('\n          <li class="rz-item ' + firstItemClass + '" data-position="' + position + '">\n            <a data-mz="true" data-module="job-contextual" data-id="' + item.promoId + '" href="' + item.url + '" class="rz-list__action">\n              <header class="rz-list__header">\n                <h4 class="heading heading--sm heading--bold">' + item.title + '</h4>\n                <p class="text text--xxs">' + subheading + '</p>\n                <div class="rz-list__right">\n                  ' + logoDiv + '\n                </div>\n              </header>\n            </a>\n          </li>\n          ');
          }
        }
      }
      var singleExclusiveClass = results.length === 1 && results[0].type === 'exclusive' ? 'rz-container-single-exclusive' : '';

      return '\n        <style>' + _styles.styles + '</style>\n        <div class="rz-container ' + singleExclusiveClass + '">\n          <h3 class="heading heading--md heading--discreet heading--underline">Recommended jobs</h3>\n          <ul class="rz-list">\n            ' + items.join('') + '\n          </ul>\n        </div>\n        ';
    }
  },
  resources: {
    endpoint: '/api/rz/resources',
    render: function render(results) {
      var items = results.map(function (item) {
        return '<li class="rz">resource <a href="' + item.url + '">' + item.text + '</a></li>';
      });
      return '<ul class="rz">' + items.join('') + '</ul>';
    }
  },
  news: {
    endpoint: '/api/rz/news',
    render: function render(results) {
      var items = results.map(function (item) {
        return '<li class="rz">news <a href="' + item.url + '">' + item.text + '</a></li>';
      });
      return '<ul class="rz">' + items.join('') + '</ul>';
    }
  },
  institute: {
    endpoint: '/api/rz/institute',
    render: function render(results) {
      var items = results.map(function (item) {
        return '<li class="rz">institute <a href="' + item.url + '">' + item.text + '</a></li>';
      });
      return '<ul class="rz">' + items.join('') + '</ul>';
    }
  }
};

module.exports = sections;

},{"../dist/styles.js":1}]},{},[3]);
